<template>
  <basic-list
    :fields="fields"
    :loading="state.loading"
    :total="state.total"
    :list="state.list"
    :show-select-col="true"
    :select-type="'singleMult'"
    :show-index-col="false"
    :show-action-col="false"
    :table-h="tableH"
    :page-index="state.pageIndex"
    :page-size="state.pageSize"
    :page-index-change="pageIndexChange"
    :page-size-change="pageSizeChange"
    :selection-change="selectionChange"
  >
    <template slot="hd-col--l">
      <!-- 添加数据角色 -->
      <el-button
        type="primary"
        v-if="buttonData('tjsjjs').has"
        size="mini"
        @click="handleAdd(buttonData('tjsjjs').name)"
        >{{ buttonData("tjsjjs").name }}</el-button
      >
      <!-- 分配数据角色 -->
      <el-button
        type="primary"
        v-if="buttonData('sjjsglfpsjjs').has"
        size="mini"
        @click="handleAllocate(selRows[0], buttonData('sjjsglfpsjjs').name)"
        >{{ buttonData("sjjsglfpsjjs").name }}</el-button
      >
      <!-- 编辑 -->
      <el-button
        v-if="buttonData('bjsjje').has"
        size="mini"
        @click="handleEdit(selRows[0], buttonData('bjsjje').name)"
        >{{ buttonData("bjsjje").name }}</el-button
      >
      <!-- 详情 -->
      <el-button
        v-if="buttonData('sjjsxq').has"
        size="mini"
        @click="handleView(selRows[0], buttonData('sjjsxq').name)"
        >{{ buttonData("sjjsxq").name }}</el-button
      >
      <!-- 删除 -->
      <el-button
        type="danger"
        v-if="buttonData('scsjjs').has"
        size="mini"
        @click="handleDelete(selRows[0])"
        >{{ buttonData("scsjjs").name }}</el-button
      >
      <!-- 导入 -->
      <el-button
        v-if="buttonData('SJJSDR').has && this.showExportButton"
        size="mini"
        @click="importDataRole"
        >{{ buttonData("SJJSDR").name }}</el-button
      >
    </template>
  </basic-list>
</template>

<script>
import { mapState } from "vuex";
import ExactList from "@/mixins/exactList";
export default {
  // computed: {
  //   ...mapState("app", ["showExportButton"]),
  // },
  mixins: [ExactList],
  props: {
    handleAdd: Function,
    handleAllocate: Function,
    handleEdit: Function,
    handleView: Function,
    handleDelete: Function,
    importDataRole: Function,
  },
  data() {
    return {
      selRows: [],
      fields: [
        { key: "roleName", name: `${this.$t('language.5o6uyb93vi50')}` },
        { key: "roleCode", name: `${this.$t('language.5o6uyb93vi40')}` },
        { key: "createUser", name: `${this.$t('language.5o6trh9vn2w0')}` },
        {
          key: "createTime",
          name: `${this.$t('language.5o6otz4p1t00')}`,
          render: (h, { row, col }) => (
            <span>{this.format(new Date(row.createTime))}</span>
          ),
        },
        { key: "source", name: `${this.$t('language.5o6otz4p1ps0')}` },
        { key: "remark", name: `${this.$t('language.5o6otz4p1w00')}` },
        { key: "rootOrgName", name: `${this.$t('language.5o6uj7uytl10')}` },
      ],
    };
  },
  methods: {
    selectionChange(rows) {
      this.selRows = rows;
    },
    format(date) {
      const map = {
        M: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        m: date.getMinutes(),
        s: date.getSeconds(),
      };
      let Y = date.getFullYear();
      for (let key in map) {
        if (map[key] < 10) map[key] = "0" + map[key];
      }
      return `${Y}-${map.M}-${map.d} ${map.h}:${map.m}:${map.s}`;
    },
  },
};
</script>
